import TimeAgo from "@/component/TimeAgo";
// import Link from "next/link";
import SVG from "react-inlinesvg";
import dynamic from "next/dynamic";
import { Fragment } from "react";
import defaultAuthor from "@/constants/defaultAuthor";
// import { useWindowSize } from "@/hooks/useIsMobile";
import siteInfo from "@/constants/siteInfo";
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
// const VDOAdSlot = dynamic(() => import("@/component/Ads/VDOAdSlot"));

const Card = ({ content, isLCP = false, haveH2 = false }) => {
  return (
    <div className="flex flex-col overflow-hidden">
      <div className="flex-shrink-0">
        <div className="relative">
          <a href={content?.canonical_url ?? ""}>
            <img
              className="w-full object-fill rounded-md"
              src={`${content?.image_small}?size=360:203`}
              title={content?.image_title}
              alt={
                content?.image_small_alt_text
                  ? content?.image_small_alt_text
                  : siteInfo?.siteName
              }
              fetchpriority={isLCP ? "high" : "low"}
              loading={isLCP ? "eager" : "lazy"}
              role="button"
              height={160}
              width={240}
            />
          </a>
          <div className="absolute left-2 w-12 bottom-[8%] md:bottom-[10%] bg-black bg-opacity-60 text-white flex items-center gap-x-2 p-1 rounded">
            <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/gallery.svg" />
            <p className="text-xl">{content?.photo_count}</p>
          </div>

        </div>
      </div>

      <div  >
        <a href={content?.canonical_url ?? ""}>
          {haveH2 ? (
            <h2
              className="text-md my-1 font-bold line-clamp-3 hover:text-primary"
              dangerouslySetInnerHTML={{
                __html: `${content?.title_short}`,
              }}
            />
          ) : (
            <h3
              className="text-md my-1 font-bold line-clamp-3 hover:text-primary"
              dangerouslySetInnerHTML={{
                __html: `${content?.title_short}`,
              }}
            />
          )}
        </a>
        <p className="flex items-center text-xs text-gray-500 font-extralight mt-1 mb:text-sm xs:text-sm">
          <img
            className="inline-block mr-1 w-4 h-4"
            alt="read video icon"
            loading="lazy"
            src={
              content?.content_type === "video"
                ? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/watchType.svg"
                : "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/readType.svg"
            }
           width="16"
  height="16"
          />
          <time dateTime={content?.datetime_published}>
            <TimeAgo dateTime={content?.datetime_published} />
          </time>{" "}
          · By{" "}
          <a
            href={
              content?.author?.[0]?.canonical_url ??
              defaultAuthor?.canonical_url
            }
            className={haveH2 ? "inline-block" : ""}
          >
            {haveH2 ? (
              <h3 className="text-primary ml-1">
                {content?.author?.[0]?.title ?? defaultAuthor.title}
              </h3>
            ) : (
              <span className="text-primary ml-1">
                {content?.author?.[0]?.title ?? defaultAuthor.title}
              </span>
            )}
          </a>
        </p>
      </div>
    </div>
  );
};

const NewsGrid = ({
  title,
  icon = "",
  newsListData = null,
  isLCP = false,
  showAds = false,
  haveH1 = false,
  isMtf2 = false, scrolled = false
}) => {
  //   console.log("newsListData", newsListData);
  // const size = useWindowSize();
  return (
    <div className="my-2">
      {showAds && (
        <AdSlot300x250
          divId={
            isMtf2
              ? "div-gpt-ad-1659434604998-0"
              : "div-gpt-ad-1659434453897-0"
          }
          minWidth="300px"
          minHeight="250px"
        />
      )}
      <div className="flex my-2 items-center">
        {icon && (
          <SVG
            className="text-primary font-bold text-2xl w-7 h-7 inline mr-2 min-w-[29px]"
            src={icon}
          />
        )}

        <div className="text-primary font-bold text-2xl mb:font-extrabold sm:font-extrabold xs:font-extrabold">
          {haveH1 ? <h1>फोटो गैलरी</h1> : <h2>फोटो गैलरी</h2>}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-2">
        {newsListData?.map((content, index) => (
          <Fragment key={index}>
            <Card
              content={content}
              isLCP={index === 0 ? isLCP : false}
              haveH2={false}
            />

            {/* {index === 2 && (
              <div className="md:col-span-3 lg:col-span-3">
                {showAds && <VDOAdSlot />}
              </div>
            )} */}
            {index === 8 && scrolled && (
              <div className="md:col-span-3 lg:col-span-3">
                <AdSlot728x90
                  divId={
                    isMtf2
                      ? "div-gpt-ad-1702014298509-3"
                      : "div-gpt-ad-1707804176041-2"
                  }
                  minWidth="720px"
                  minHeight="90px"
                />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default NewsGrid;
